import { UtilityText } from "component/text";
import { componentWithVariants, demoFile, variant, story, HOVER } from "system/demo";
import { DocumentLevelTooltip, InfoTag, ToolTip } from "../tooltip";
import { Tools } from "@carbon/icons-react";
import { StyleSheet, View } from "react-native";
import { ShadowBox } from "component/basics";
import { colorBlackHover, colorSurfacePrimary, colorTextPrimary } from "component/color";
import { Tag } from "component/button";

demoFile("open-modules/zdf/component/tooltip", {
    designUrl:
        "https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=9187-10638&t=w6l8M7VhyJfaBTd1-0",
});

componentWithVariants("InfoTag", InfoTagDemo, {}, [
    variant(
        "With text text",
        {
            args: { text: "This is a simple text" },
        },
        [story("Hover", [HOVER("infotag-target")])]
    ),
    variant(
        "With label widget",
        {
            args: { labelWidget: <CustomDocumentLevelTooltipWidget /> },
        },
        [story("Hover", [HOVER("infotag-target")])]
    ),
]);

componentWithVariants("ToolTip", ToolTipDemo, {}, [
    variant(
        "Default",
        {
            args: { text: "Tooltip", children: <DemoTag /> },
        },
        [story("Hover", [HOVER("tooltip-target")])]
    ),
    variant(
        "Custom offset value",
        {
            args: { text: "Tooltip", offset: 50, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("tooltip-target")])]
    ),
    variant(
        "Custom width",
        {
            args: { text: "Tooltip with a long text across multiple lines", width: 175, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("tooltip-target")])]
    ),
    variant(
        "Custom tooltip widget",
        {
            args: { toolTipWidget: <CustomTooltipWidget />, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("tooltip-target")])]
    ),
]);

componentWithVariants("DocumentLevelTooltip", DocumentLevelTooltipDemo, {}, [
    variant(
        "Default",
        {
            args: { text: "Tooltip", children: <DemoTag /> },
        },
        [story("Hover", [HOVER("document-level-tooltip-target")])]
    ),
    variant(
        "Custom offset value",
        {
            args: { text: "Tooltip", offset: 50, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("document-level-tooltip-target")])]
    ),
    variant(
        "Custom width",
        {
            args: { text: "Tooltip with a long text across multiple lines", width: 175, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("document-level-tooltip-target")])]
    ),
    variant(
        "Custom tooltip widget",
        {
            args: { tooltipWidget: <CustomDocumentLevelTooltipWidget />, children: <DemoTag /> },
        },
        [story("Hover", [HOVER("document-level-tooltip-target")])]
    ),
]);

function InfoTagDemo(props) {
    return <InfoTag {...props} testID="infotag-target" />;
}

function ToolTipDemo(props) {
    return <ToolTip {...props} testID="tooltip-target" />;
}

function DocumentLevelTooltipDemo(props) {
    return <DocumentLevelTooltip {...props} testID="document-level-tooltip-target" />;
}

function DemoTag() {
    return <Tag text={"Hover over me"} textColor={colorBlackHover} />;
}

const CustomTooltipWidgetStyle = StyleSheet.create({
    container: {
        width: 220,
        gap: 8,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    textContent: {
        display: "flex",
        flexDirection: "column",
    },
});

function CustomTooltipWidget() {
    const s = CustomTooltipWidgetStyle;

    return (
        <View style={s.container}>
            <Tools />
            <View style={s.textContent}>
                <UtilityText weight="strong" text="I'm a custom tooltip widget!" />
                <UtilityText text="Fill me with custom content." />
            </View>
        </View>
    );
}

const CustomDocumentLevelTooltipWidgetStyle = StyleSheet.create({
    container: {
        width: 230,
        gap: 8,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: 12,
        backgroundColor: colorSurfacePrimary,
        borderRadius: 8,
    },
    textContent: {
        display: "flex",
        flexDirection: "column",
    },
});

function CustomDocumentLevelTooltipWidget() {
    const s = CustomDocumentLevelTooltipWidgetStyle;

    return (
        <ShadowBox>
            <View style={s.container}>
                <Tools color={colorTextPrimary} />
                <View style={s.textContent}>
                    <UtilityText weight="strong" text="I'm a custom tooltip widget!" />
                    <UtilityText text="Fill me with custom content." />
                </View>
            </View>
        </ShadowBox>
    );
}